// extracted by mini-css-extract-plugin
export default {"main":"UsuarioSelector_main__H0vtc"};